import ListTable from "./ListTable";

const ListSelesai = (props) => {
  return (
    <ListTable
      {...props}
      title="SELESAI"
      rowFilter={(el) => el.tanggal_pulang && el.tanggal_pulang}
    />
  );
};

export default ListSelesai;
